const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 303.188 303.188",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E8E8E8"
    },
    points: "219.821,0 32.842,0 32.842,303.188 270.346,303.188 270.346,50.525  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 92.817,
    y: 166.37,
    style: {
      fill: "#D1D3D3"
    },
    width: 49.543,
    height: 12.865
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.817,
    y: 141.729,
    style: {
      fill: "#D1D3D3"
    },
    width: 107.543,
    height: 12.865
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.817,
    y: 117.087,
    style: {
      fill: "#D1D3D3"
    },
    width: 117.551,
    height: 12.865
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.817,
    y: 92.445,
    style: {
      fill: "#D1D3D3"
    },
    width: 82.209,
    height: 12.865
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.817,
    y: 67.804,
    style: {
      fill: "#D1D3D3"
    },
    width: 117.551,
    height: 12.865
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A4A9AD"
    },
    d: "M113.189,273.871h-12.963v-37.379H88.511v-10.6h36.361v10.6h-11.683V273.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A4A9AD"
    },
    d: "M174.952,273.871h-14.998l-9.352-14.998l-9.256,14.998h-14.669l15.917-24.547l-14.965-23.433 h14.373l8.664,14.834l8.336-14.834h14.801l-15.195,24.449L174.952,273.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A4A9AD"
    },
    d: "M201.502,273.871h-12.963v-37.379h-11.716v-10.6h36.361v10.6h-11.683v37.379H201.502z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A4A9AD"
    },
    points: "227.64,25.263 32.842,25.263 32.842,0 219.821,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D3D3"
    },
    points: "219.821,50.525 270.346,50.525 219.821,0  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextSvg);
export default __webpack_public_path__ + "static/media/textSvg.4299945cc37972a05a994fbc8478d546.svg";
export { ForwardRef as ReactComponent };